module.exports = __webpack_public_path__ + "c72f974e5d532a6dc4ff3cc3a458df9c.jpg";